import { getTaskEventsById } from '@dispatch/shared/services';
import { useQuery } from 'react-query';

export const useGetTaskEvents = (id: string, pageSize = 50) => {
  const { data, status, refetch } = useQuery(['taskEvents', id], () =>
    getTaskEventsById(id, pageSize)
  );

  return {
    taskEvents: data,
    taskEventsStatus: status,
    fetchTaskEvents: refetch,
  };
};
